import PropTypes from 'prop-types';
import React from 'react';
import I18n from 'i18n-js';
import { RCAlertBox } from '@reverbdotcom/cadence/components';

const ErrorMessage = (props) => {
  const message = props.message || I18n.t('discovery.payoutMethod.defaultErrorMessage');
  const { messageWithLinks } = props;

  if (messageWithLinks) {
    return (
      <RCAlertBox type="error" small>
        <p
          className="mb-0"
          dangerouslySetInnerHTML={{ __html: messageWithLinks }}
        />
      </RCAlertBox>
    );
  }

  return (
    <RCAlertBox type="error" small>
      <p className="mb-0">
        {message}
      </p>
    </RCAlertBox>
  );
};

ErrorMessage.propTypes = {
  message: PropTypes.string,
  color: PropTypes.string,
  small: PropTypes.bool,
};

export default ErrorMessage;
